/*
 * Membership signup controller (AAC membership rebuild, issue #84).
 * Native Shopify Subscriptions, one page: primary member + inline additional-member repeater + live total,
 * submitted as a multi-line /cart/add (each line carries its own selling_plan + member name property).
 * No framework; self-running + idempotent.
 */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function init(root) {
    if (!root || root.__skMsBound) return;
    root.__skMsBound = true;

    var cfgEl = root.querySelector('[data-sk-ms-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var addonTypes = cfg.addonTypes || [];
    var rowsEl = root.querySelector('[data-sk-ms-rows]');
    var addBtnsEl = root.querySelector('[data-sk-ms-add-btns]');
    var totalEl = root.querySelector('[data-sk-ms-total]');
    var primaryEl = root.querySelector('[data-sk-ms-primary]');
    var emailEl = root.querySelector('[data-sk-ms-email]');
    var coachEl = root.querySelector('[data-sk-ms-coach]');
    var submitEl = root.querySelector('[data-sk-ms-submit]');
    var errorEl = root.querySelector('[data-sk-ms-error]');

    /* Referral capture (issue #394). Present only on products tagged `referral-capture`, and never on
       the Add-a-Member page, so every one of these can legitimately be null. */
    var refBox = root.querySelector('[data-sk-ms-referral]');
    var refPanel = root.querySelector('[data-sk-ms-ref-panel]');
    var refNameEl = root.querySelector('[data-sk-ms-ref-name]');
    var refToggles = root.querySelectorAll('[data-sk-ms-ref-toggle]');

    var ctaLabel = submitEl ? submitEl.textContent : 'Join Now';
    var addonOnly = !!cfg.addonOnly; // add-a-member page: no base membership line

    var rows = []; // { type, name }

    function recalc() {
      var cents = addonOnly ? 0 : cfg.basePrice;
      rows.forEach(function (r) { cents += r.type.price; });
      if (totalEl) totalEl.innerHTML = money(cents) + '<span class="sk-ms__total-unit"> / month</span>';
    }

    function renderRows() {
      if (!rowsEl) return;
      rowsEl.innerHTML = '';
      rows.forEach(function (r, i) {
        var row = document.createElement('div');
        row.className = 'sk-ms__row';

        // Header line: role label + monthly price + remove button.
        var head = document.createElement('div');
        head.className = 'sk-ms__row-head';

        var inputId = 'sk-ms-addon-' + i;

        var label = document.createElement('label');
        label.className = 'sk-ms__row-label';
        label.setAttribute('for', inputId);
        label.textContent = r.type.label;

        var price = document.createElement('span');
        price.className = 'sk-ms__row-price';
        price.textContent = '+' + r.type.priceText + '/mo';

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sk-ms__row-remove';
        remove.setAttribute('aria-label', 'Remove ' + r.type.label);
        remove.innerHTML = '&times;';
        remove.addEventListener('click', function () { rows.splice(i, 1); renderRows(); recalc(); });

        head.appendChild(label);
        head.appendChild(price);
        head.appendChild(remove);

        // Full-width name input below the header.
        var input = document.createElement('input');
        input.type = 'text';
        input.id = inputId;
        input.className = 'sk-ms__input sk-ms__row-input';
        input.placeholder = 'Full name';
        input.autocomplete = 'name';
        input.value = r.name || '';
        input.addEventListener('input', function () { r.name = input.value; });

        row.appendChild(head);
        row.appendChild(input);
        rowsEl.appendChild(row);
      });
      recalc();
    }

    // One "Add …" button per add-on type.
    if (addBtnsEl) {
      addonTypes.forEach(function (type) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sk-ms__add-btn';
        b.textContent = '+ Add ' + type.label;
        b.addEventListener('click', function () { rows.push({ type: type, name: '' }); renderRows(); });
        addBtnsEl.appendChild(b);
      });
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    /* ---- Referral capture (issue #394) ---------------------------------------------------------
       The panel is shown/hidden with the `hidden` ATTRIBUTE rather than an inline style so it stays
       out of the accessibility tree too. Switching to "No" clears the typed name, so a customer who
       types a referrer and then changes their mind cannot leave a stale value behind that would still
       be read at submit time. */
    function refChoice() {
      for (var i = 0; i < refToggles.length; i++) {
        if (refToggles[i].checked) return refToggles[i].value;
      }
      return '';
    }

    /* Trim and collapse runs of whitespace. Capitalisation is left exactly as typed on purpose:
       title-casing mangles real names (McDonald -> Mcdonald, O'Brien -> O'brien). Case is folded at
       REPORT time instead — see tools/shopify-cli/src/scripts/aac-referral-report.mjs. */
    function refName() {
      if (!refNameEl) return '';
      return refNameEl.value.replace(/\s+/g, ' ').replace(/^ | $/g, '');
    }

    function syncRefPanel() {
      if (refPanel) refPanel.hidden = refChoice() !== 'yes';
    }

    for (var ri = 0; ri < refToggles.length; ri++) {
      refToggles[ri].addEventListener('change', function () {
        var yes = refChoice() === 'yes';
        syncRefPanel();
        if (!yes && refNameEl) refNameEl.value = '';
        showError('');
        if (yes && refNameEl) refNameEl.focus();
      });
    }

    /* Initial sync, and again on bfcache restore. Nothing is pre-selected in the markup, but Chrome
       restores radio state on a reload or a back-navigation WITHOUT firing `change` — observed on
       preview 2026-09-01. Left unsynced that produces a dead end: "Yes" comes back selected while the
       name panel is still `hidden`, so the submit guard demands a referrer name the customer has no
       visible box to type into. (Same class of bug as the autofill/back-restore note in
       product-pickup-details.liquid.) `pageshow` covers the bfcache path, where no script re-runs. */
    syncRefPanel();
    window.addEventListener('pageshow', syncRefPanel);

    function submit() {
      showError('');
      var primary = (primaryEl && primaryEl.value || '').trim();
      if (!primary) {
        showError(addonOnly ? 'Please enter your name (the existing member).' : 'Please enter who this membership is for.');
        primaryEl && primaryEl.focus();
        return;
      }
      var email = (emailEl && emailEl.value || '').trim();
      if (addonOnly) {
        if (!email) {
          showError('Please enter the account email on your existing membership.');
          emailEl && emailEl.focus();
          return;
        }
        if (!rows.length) {
          showError('Add at least one member to continue.');
          return;
        }
      }
      for (var i = 0; i < rows.length; i++) {
        if (!(rows[i].name || '').trim()) {
          showError('Please enter a name for each ' + (addonOnly ? 'member' : 'additional member') + ' (or remove the empty one).');
          return;
        }
      }

      /* Referral (issue #394). A choice is required — neither radio ships pre-selected, so a blank
         answer is a real "we did not ask well enough" rather than a silent default that loses the
         referrer their credit. Two words are required because `Jane` and `Jane Smith` can never be
         reconciled once the order is written. */
      var referredBy = '';
      if (refBox) {
        var choice = refChoice();
        if (!choice) {
          showError('Please let us know whether a member referred you.');
          if (refToggles.length) refToggles[0].focus();
          return;
        }
        if (choice === 'yes') {
          referredBy = refName();
          if (!referredBy) {
            showError('Please enter the name of the member who referred you.');
            refNameEl && refNameEl.focus();
            return;
          }
          if (referredBy.indexOf(' ') === -1) {
            showError('Please enter their first and last name.');
            refNameEl && refNameEl.focus();
            return;
          }
        }
      }

      var items = [];
      if (!addonOnly) {
        var mainProps = { 'Member name': primary };
        var coach = (coachEl && coachEl.value || '').trim();
        if (coach) mainProps['Preferred coach'] = coach;
        /* Main membership line only. Deliberately NOT copied onto the add-on lines: one signup is one
           referral, and repeating it per line would inflate any count taken over line items. */
        if (referredBy) mainProps['Referred by'] = referredBy;
        items.push({
          id: cfg.mainVariantId,
          quantity: 1,
          selling_plan: cfg.mainPlanId,
          properties: mainProps
        });
      }
      rows.forEach(function (r) {
        var props = { 'Member name': r.name.trim(), 'Membership': addonOnly ? (r.type.label || '') : cfg.productTitle };
        if (addonOnly) {
          props['Adding to existing member'] = primary;
          props['Existing member email'] = email;
        }
        items.push({
          id: r.type.variantId,
          quantity: 1,
          selling_plan: r.type.planId,
          properties: props
        });
      });

      /* Never rejects. The .catch() at the end of the add chain re-enables the button and shows a
         network error — this must not be able to trigger it after the add has already succeeded. */
      function writeReferralAttribute() {
        if (!refBox) return Promise.resolve();
        var url = root.getAttribute('data-cart-update') || '/cart/update.js';
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Referred by': referredBy } })
        }).then(function () {}, function () {});
      }

      submitEl.disabled = true;
      submitEl.textContent = 'Adding…';
      fetch(root.getAttribute('data-cart-add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
        .then(function (r) {
          if (!r.ok) {
            showError((r.body && r.body.description) || 'Could not add to cart. Please try again.');
            submitEl.disabled = false;
            submitEl.textContent = ctaLabel;
            return;
          }
          /* Referral, order level (issue #394). Written AFTER the add succeeds, never before: an
             abandoned signup attempt must not leave a referrer attached to the session's cart where it
             could ride along on an unrelated later order. Always written when the box is present —
             including as an empty string for a "No" answer — so a stale value from an earlier attempt
             is cleared rather than inherited.

             ⚠️ Best effort by design. This is telemetry; the sale has already been added and the line
             item property already carries the name. A failure here must never cost the customer their
             cart, so every outcome falls through to the same redirect. */
          return writeReferralAttribute().then(function () {
            window.location.href = root.getAttribute('data-cart-url') || '/cart';
          });
        })
        .catch(function () {
          showError('Network error. Please try again.');
          submitEl.disabled = false;
          submitEl.textContent = ctaLabel;
        });
    }

    if (submitEl) submitEl.addEventListener('click', submit);
    recalc();
  }

  function boot() {
    document.querySelectorAll('[data-sk-ms]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
